export default "__VITE_ASSET__5cf9dd74__"